import {gql, useMutation} from '@apollo/client'

const updateEventDetailsMutation = gql`
  mutation UpdateEventDetails($eventId: Int, $eventName: String!, $isActive: Boolean!, $hasRecording: Boolean!) {
    updateEvent(eventId: $eventId, eventName: $eventName, isActive: $isActive, hasRecording: $hasRecording) {
      updateEvent {
        EVENT_ID
        EVENT_NAME
        USER_EMAIL
        IS_ACTIVE
        HAS_RECORDING
      }
    }
  }
`

export const useUpdateEventDetails = () => {
  return useMutation(updateEventDetailsMutation, {
    context: {clientName: 'adminPanel'}
  })
}
